export default __webpack_public_path__ + "static/media/orange_pencils.4d68b760.png";